// Lib
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

// Selectors
import { activePopupSelector } from './popupOpenSelector';

const mapStateToProps = createSelector(
    activePopupSelector,
    (state, ownProps) => ownProps.popupId,
    (popupState, popupId) => ({
        isPopupOpen: popupState.has(popupId),
    }),
);

const PopupVisible = (props) => {
    const { children, isPopupOpen } = props;

    if (!isPopupOpen) return null;
    return children;
};

PopupVisible.propTypes = {
    popupId: PropTypes.string.isRequired,
    children: PropTypes.node,
    isPopupOpen: PropTypes.bool,
};

export default connect(mapStateToProps)(PopupVisible);
